import { Box, useTheme } from "@mui/material";
import { FieldCommentCard } from "@platform/btx-grid-components";
import { schemeAiPalette } from "@platform/design-system";

import { cornerTriangleSx } from "./cellOverlayStyles";
import { useHoverPopover } from "./useHoverPopover";

export interface FieldCommentCornerProps {
  comment: string;
}

export const FieldCommentCorner = ({
  comment,
}: FieldCommentCornerProps): React.JSX.Element => {
  const theme = useTheme();
  const aiPalette = schemeAiPalette(theme);
  const popover = useHoverPopover();

  return (
    <>
      <Box
        data-testid="field-comment-corner"
        onMouseEnter={popover.onTriggerEnter}
        onMouseLeave={popover.onTriggerLeave}
        sx={{
          ...cornerTriangleSx("top-right", aiPalette.comment),
          zIndex: 2,
          cursor: "pointer",
        }}
      />
      <FieldCommentCard
        comment={comment}
        anchorEl={popover.anchorEl}
        open={popover.open}
        onMouseEnter={popover.onCardEnter}
        onMouseLeave={popover.onCardLeave}
      />
    </>
  );
};
